<p-sidebar [visible]="true"
           [position]="'right'"
           [modal]="true"
           (onHide)="onSideBarHide()"
           [style]="{width:'650px'}">

    <ng-template pTemplate="header">Edit Group Details</ng-template>
    <ng-template pTemplate="content">
        <div class="field" style="margin-top: 20px;">
            <div>Name</div>
            <input pInputText [(ngModel)]="group.Name" />
        </div>
        <div class="field" style="margin-top: 20px;">
            <div>Description</div>
            <textarea rows="5" cols="30" pInputTextarea [(ngModel)]="group.Description"></textarea>
        </div>
        <div class="field">
            <div class="flex flex-wrap gap-3">
                <div class="flex align-items-center">
                    <p-radioButton name="geometryTypeRadio"
                                   [value]="geometryType.Circle"
                                   [(ngModel)]="geometryTypeId"
                                   (onClick)="onGeometryTypeClick()"
                                   inputId="geometryTypeCircle"></p-radioButton>
                    <label for="geometryTypeCircle" class="ml-2">Radius</label>
                </div>
                <div class="flex align-items-center">
                    <p-radioButton name="geometryTypeRadio"
                                   [value]="geometryType.Polygon"
                                   [(ngModel)]="geometryTypeId"
                                   (onClick)="onGeometryTypeClick()"
                                   inputId="geometryTypePolygon"></p-radioButton>
                    <label for="geometryTypePolygon" class="ml-2">Geo Zone/Polygon</label>
                </div>
            </div>
            <div id="editGroupMap" style="height: 420px; margin-top: 4px;"></div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="flex-row" style="padding: 30px;">
            <div class="filler"></div>
            <div>
                <button pButton type="button" label="Discard" class="p-button-outlined p-button-danger"
                        (click)="onSideBarHide()"></button>
            </div>
            <div style="margin-left: 20px;">
                <button pButton type="button" label="Save Changes"
                        [disabled]="!group.Name"
                        (click)="onSaveClick()"></button>
            </div>
        </div>
    </ng-template>
</p-sidebar>

<p-toast position="top-right"></p-toast>
